import Router, { Route, route } from 'preact-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Login } from './pages/Login'
import { RecentShows } from './pages/RecentShows'
import { AllShows } from './pages/AllShows'
import { ShowDetailsRoute } from './components/ShowDetailsRoute'
import { useEffect } from 'preact/hooks'
import { apiService } from './services/api'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

function AppRouter() {
  useEffect(() => {
    // Check if we have stored credentials on mount
    const hasCredentials = apiService.getCredentials() !== null

    if (hasCredentials && window.location.pathname === '/') {
      // If authenticated and on login page, redirect to shows
      route('/shows')
    } else if (!hasCredentials && window.location.pathname !== '/') {
      // If not authenticated and not on login page, redirect to login
      route('/')
    }
  }, [])

  // Always render the current route, auth checks happen in useEffect
  return (
    <Router>
      <Route path="/" component={Login} />
      <Route path="/shows" component={RecentShows} />
      <Route path="/shows/all" component={AllShows} />
      <Route path="/shows/:id" component={ShowDetailsRoute} />
    </Router>
  )
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppRouter />
    </QueryClientProvider>
  )
}
